import { render, staticRenderFns } from "./codePupop2.vue?vue&type=template&id=8efaa19c&scoped=true&"
import script from "./codePupop2.vue?vue&type=script&lang=js&"
export * from "./codePupop2.vue?vue&type=script&lang=js&"
import style0 from "./codePupop2.vue?vue&type=style&index=0&id=8efaa19c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efaa19c",
  null
  
)

export default component.exports